import { render } from "./DeclencheurAbandonPanier.vue?vue&type=template&id=319f378c"
import script from "./DeclencheurAbandonPanier.vue?vue&type=script&lang=ts"
export * from "./DeclencheurAbandonPanier.vue?vue&type=script&lang=ts"
script.render = render

export default script